import styled, { createGlobalStyle } from "styled-components";

export const Title = styled("h4")`
  margin: 0px;
  font-size: 16px;
  display: flex;
  align-items: space-between;
  gap: 25px;
`;

export const Center = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 20px 20px;
`;

export const GlobalStyle = createGlobalStyle`
  .custom-table {
    &.pmc-table{
      height: calc(100% - 75px - 20px);
    }
  }
`;

export const Tabs = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  max-width: fit-content;
`;

export const Tab = styled("button")`
  border: 1px solid #f02a2b;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  ${({ isActive }) => (isActive ? `background-color: #f02a2b; color: white;` : `background-color: transparent; color: #f02a2b;`)}

  &:hover,
  &:focus,
  &:active {
    outline: 0px;
    border: 1px solid #f02a2b;
    background-color: #f02a2b;
    color: white;
  }
`;

export const TabContent = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 420px;
`;
